import { useEffect, useState } from 'react';
import { DateHelper } from 'src/shared/helpers/dateHelper';
import { AutojobResponse } from 'src/modules/dashboard/models/autojobResponse';
import { getAllAutojobs2 } from 'src/shared/services/autojobService';

/**
 * Nästa körning för ett autojobb av en viss typ, formaterad för visning.
 *
 * Jobben skapas och tas bort av API:et när inställningarna som styr dem sparas, så den som slår
 * på en inställning ska kunna se när mailen faktiskt går ut. Tiden läses från jobbet i stället
 * för att hårdkodas, eftersom den kan ändras i efterhand.
 *
 * Returnerar tom sträng när jobbet inte finns ännu, till exempel innan inställningen sparats.
 */
export const useAutojobNextRun = (assemblyName: string, enabled: boolean) => {
  const [nextRun, setNextRun] = useState('');

  useEffect(() => {
    if (!enabled) {
      setNextRun('');
      return undefined;
    }

    let cancelled = false;

    // Status 1 är de väntande jobben. Ett kundregister har en handfull, så hela listan hämtas
    // och matchas här i stället för att lita på fritextsökningen i filtret.
    getAllAutojobs2({ status: 1, pageSize: 100 })
      .then((result) => {
        if (cancelled) return;

        const job = (result.data.results ?? []).find((x: AutojobResponse) => x.assemblyName === assemblyName);

        setNextRun(job && DateHelper.isValid(job.startTimeStamp) ? DateHelper.getDateTime(job.startTimeStamp) : '');
      })
      .catch(() => {
        // Saknad behörighet eller nätverksfel ska inte störa inställningssidan.
        if (!cancelled) setNextRun('');
      });

    return () => {
      cancelled = true;
    };
  }, [assemblyName, enabled]);

  return nextRun;
};
